var _desc, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconTimeCircle32Px(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "32px",
    height: "32px",
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "4DAEEC6D-5003-489A-9D1E-768B4198A8AD_SVG") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with sketchtool.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Eraklient",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Arveldus---Krediitkaart",
    transform: "translate(-497.000000, -199.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-36",
    transform: "translate(208.000000, 160.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-29",
    transform: "translate(289.000000, 27.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon_Time-Circle_32px",
    transform: "translate(0.000000, 12.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M32,16 C32,24.8365565 24.8365565,32 16,32 C7.16344348,32 0,24.8365565 0,16 C0,7.16344348 7.16344348,0 16,0 C24.8365565,0 32,7.16344348 32,16 Z",
    id: "Stroke-1",
    fill: "#E7E7E7"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Stroke-3",
    stroke: "#000000",
    strokeWidth: 2,
    points: "16.6956522 5.17391304 16.6956522 16.6956522 9.34782609 16.6956522"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconTimeCircle32Px);
export default __webpack_public_path__ + "static/media/Icon_Time-Circle_32px.270c7dde28c92c170caec2cfe513d0c7.svg";
export { ForwardRef as ReactComponent };